import React, { useState, useEffect, useCallback } from 'react';
import { cn } from '../../utils';
import { TreeContext, TreeProps } from './TreeContext';
import TreeNode from './TreeNode';
import Spinner from '../Spinner/Spinner';

function Tree({
    children,
    activeItemIds = [],
    initialOpenNodes = [],
    className,
    defaultIcon = true,
    navIcon = true,
    title,
    titleClassName,
    loading = false,
}: TreeProps) {
    const [expandedNodes, setExpandedNodes] =
        useState<string[]>(initialOpenNodes);

    useEffect(() => {
        setExpandedNodes(initialOpenNodes);
    }, [initialOpenNodes.length > 0]);

    const toggleNode = useCallback((id: string) => {
        setExpandedNodes(prev =>
            prev.includes(id)
                ? prev.filter(nodeId => nodeId !== id)
                : [...prev, id],
        );
    }, []);

    const contextValue = React.useMemo(
        () => ({
            expandedNodes,
            activeItemIds,
            toggleNode,
            defaultIcon,
            navIcon,
        }),
        [expandedNodes, activeItemIds, toggleNode, defaultIcon, navIcon],
    );

    if (loading) {
        return (
            <div className="alli-flex alli-h-full alli-w-full alli-items-center alli-justify-center">
                <Spinner size="lg" />
            </div>
        );
    }

    return (
        <TreeContext.Provider value={contextValue}>
            <div
                className={cn(
                    'alli-max-h-full alli-w-60 alli-bg-white alli-text-sm alli-text-blue-gray-700',
                    className,
                )}>
                {title && (
                    <h3
                        className={cn(
                            'alli-px-4 alli-py-2 alli-font-semibold',
                            titleClassName,
                        )}>
                        {title}
                    </h3>
                )}
                {children}
            </div>
        </TreeContext.Provider>
    );
}

Tree.Node = TreeNode;

export default Tree;
